/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    avatar01,
    avatar02,
    avatar03,
    doctor_thumb_01,
} from "./imagepath";
import logo from "../assets/images/hisalogo.png";


const Header = (props) => {

    const [isMiniSidebar, setIsMiniSidebar] = useState(false);

    useEffect(() => {
        const handleMouseOver = (e) => {
            e.stopPropagation();

            if (isMiniSidebar && document.getElementById("toggle_btn").offsetParent !== null) {
                const sidebar = document.querySelector(".sidebar");
                if (sidebar.contains(e.target)) {
                    setIsMiniSidebar(false);
                    // Perform actions when mouse is over sidebar
                } else {
                    setIsMiniSidebar(true);
                    // Perform actions when mouse is not over sidebar
                }
            }
        };

        document.addEventListener("mouseover", handleMouseOver);

        return () => {
            document.removeEventListener("mouseover", handleMouseOver);
        };
    }, [isMiniSidebar]);
    
    const handlesidebar = () => {

        document.body.classList.toggle("mini-sidebar");
    };

    const handlesidebarmobilemenu = () => {
        document.body.classList.toggle("slide-nav");
    };

    
    return (
        <>
            {/* Header */}
            <div className="header">
                {/* Logo */}
                <div className="header-left">
                    <Link to="/dashboard" className="logo">
                        <img src={logo} alt="Logo" />
                    </Link>
                    <Link to="/dashboard" className="logo logo-small">
                        <img src={logo} alt="Logo" width="30" height="30" />
                    </Link>
                </div>
                <Link to="#" id="toggle_btn" onClick={handlesidebar}>
                    <i className="fe fe-text-align-left"></i>
                </Link>
                {/* /Logo */}
                <div className="top-nav-search">
                    <form>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search here"
                        />
                        <button className="btn" type="submit">
                            <i className="fa fa-search" />
                        </button>
                    </form>
                </div>

                {/* Mobile Menu Toggle */}
                <Link
                    to="#"
                    className="mobile_btn"
                    id="mobile_btn"
                    onClick={() => handlesidebarmobilemenu()}
                >
                    <i className="fa fa-bars" />
                </Link>
                {/* /Mobile Menu Toggle */}
            </div>
            {/* /Header */}
        </>
    );
};

export default Header;
